'use strict';

var _ = require('lodash');
var ChartFbcApplicabilityService = function ChartFbcApplicabilityService($q, $filter, dataRetrieverService, dataRetrieverConstantsService, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getData() {
    var dataRetriver = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.FARES_MODE);
    return [dataRetriver.localSortApplied().retrieveComponentData('fbc-applicability-chart'), dataRetriver.getSearchCriteriaRules()];
  }
  function getGrouped(data, min, max) {
    function getKeyFromElement(element) {
      var minKey = min.valueOf();
      var maxKey = max.valueOf();
      var startKey = element.startDate.valueOf();
      var endKey = element.endDate.valueOf();
      return '' + _.max([minKey, startKey]) + _.min([maxKey, endKey]);
    }
    function getStartDate(startDate, endDate) {
      if (min.isAfter(startDate)) {
        if (min.isAfter(endDate)) {
          return endDate;
        } else {
          return min;
        }
      }
      return startDate;
    }
    function getEndDate(endDate, startDate) {
      if (max.isBefore(endDate) && max.isAfter(startDate)) {
        return max;
      }
      return endDate;
    }
    var groupedDataFromApiByDay = _.groupBy(data, getKeyFromElement);
    var grouped = [];
    _.forEach(groupedDataFromApiByDay, function (values) {
      var endDate = values[0].endDate;
      var startDate = values[0].startDate;
      grouped.push({
        startDate: getStartDate(startDate, endDate),
        endDate: getEndDate(endDate, startDate),
        fares: values
      });
    });
    return grouped;
  }
  function getXAxisValues(dateRange) {
    //range from search criteria in in current time zone, but chart range - in UTC
    var min = dateRange[0].clone();
    var max = dateRange[1].clone();
    var xAxisValues = [];
    while (!min.isAfter(max)) {
      xAxisValues.push(min.clone());
      min = min.add(1, 'days');
    }
    return xAxisValues;
  }
  function createDataForChart(data, dateRange) {
    return {
      grouped: getGrouped(data, dateRange[0], dateRange[1])
    };
  }
  function createClazzes(selectedClasses, itemColor, itemTextColors) {
    return _.transform(selectedClasses, function (result, clazz, idx) {
      result.push({
        label: clazz,
        css: 'fbc-applicability-legend-item-' + (idx + 1),
        backgroundColorStyle: {
          'background-color': itemColor[idx]
        },
        textColor: itemTextColors[idx]
      });
    });
  }
  function getTimePeriodString(from, to) {
    if (!from || !to) {
      return '';
    }
    var monthFormat = momentService.FORMAT.MONTH_FULL;
    var diff = momentService.twix(from, to, {
      allDay: true
    });
    if (diff.length('months') > 1) {
      monthFormat = momentService.FORMAT.MONTH;
    }
    return diff.format({
      implicitYear: false,
      monthFormat: monthFormat
    });
  }
  function createDateRange(searchCriteria, data) {
    var departureRangeBetween = _.find(searchCriteria, {
      category: 'Time & Date',
      criterion: 'Departure Date',
      operator: 'Between'
    });
    if (departureRangeBetween) {
      return [departureRangeBetween.leftOperand, departureRangeBetween.rightOperand];
    } else {
      if (!data || data.length === 0) {
        return '';
      }
      var min = data[0].startDate;
      var max = data[0].endDate;
      _.forEach(data, function (item) {
        if (min.isAfter(item.startDate)) {
          min = item.startDate;
        }
        if (max.isBefore(item.endDate)) {
          max = item.endDate;
        }
      });
      return [min, max];
    }
  }
  function prepareDataForTooltip(data) {
    var from = rmMomentFormat(data.startDate, 'MONTH_SHORT_NAME_DAY');
    var to = data.startDate.month() === data.endDate.month() ? rmMomentFormat(data.endDate, 'DAY_OF_MONTH') : rmMomentFormat(data.endDate, 'MONTH_SHORT_NAME_DAY');
    var date = from + '-' + to;
    var name = data.fbc;
    var value = data.fareValue.toFixed(2);
    return {
      date: date,
      name: name,
      value: value
    };
  }
  function getMinRangeSize(groupedDate) {
    var grouped = groupedDate.grouped;
    if (!grouped || grouped.length === 0) {
      return 1;
    }
    var minRange = grouped[0].endDate - grouped[0].startDate;
    for (var i = 0; i < grouped.length; i++) {
      var current = grouped[i];
      var curRange = current.endDate - current.startDate;
      if (curRange < minRange) {
        minRange = curRange;
      }
    }
    //1000 * 60 * 60 * 24
    var oneDay = 86400000;
    var minDayRange = minRange / oneDay + 1;
    return minDayRange;
  }
  return {
    getData: getData,
    createDataForChart: createDataForChart,
    createClazzes: createClazzes,
    getTimePeriodString: getTimePeriodString,
    createDateRange: createDateRange,
    getXAxisValues: getXAxisValues,
    prepareDataForTooltip: prepareDataForTooltip,
    getMinRangeSize: getMinRangeSize
  };
};
ChartFbcApplicabilityService.$inject = ['$q', '$filter', 'DataRetrieverService', 'DataRetrieverConstantsService', 'MomentService'];
module.exports = ChartFbcApplicabilityService;